import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useFormController from '../hooks/useFormController';
import formControllerState from '../utils/formControllerState';

const FormLabel = (props) => {
  const {
    children,
    legend,
    optional,
    ...rest
  } = props;

  const formControl = useFormController();
  const fcs = formControllerState({
    props,
    formControl,
    states: ['required', 'disabled'],
  });

  const Tag = legend ? 'legend' : 'label';

  const classes = classNames('sui-font-regular sui-text-base sui-leading-tight sui-flex sui-items-baseline sui-relative sui-mb-2', {
    'sui-text-primary': !fcs.disabled,
    'sui-text-inactive': fcs.disabled
  });

  const optionalClass = 'sui-font-regular sui-text-xs sui-leading-tight sui-text-left sui-text-subtle';

  return (
    <Tag className={classes} {...rest}>
      {children}
      {fcs.required && (
        <span aria-hidden>*</span>
      )}
      {optional && !fcs.required && (
        <p className={optionalClass}>
          &nbsp;(optional)
        </p>
      )}
    </Tag>
  );
};

FormLabel.displayName = 'FormLabel';

FormLabel.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  htmlFor: PropTypes.string,
  legend: PropTypes.bool,
  optional: PropTypes.bool,
  required: PropTypes.bool
};

FormLabel.defaultProps = {
  children: null,
  disabled: undefined,
  htmlFor: undefined,
  legend: false,
  optional: false,
  required: undefined,
};

export { FormLabel };
